export class CoreZone {
  czFrom: "ja" | "nein" | "" = "";
  czTo: "ja" | "nein" | "" = "";
}